import React, { Component } from "react";
import Form from "react-validation/build/form";

import {
  renderTextBox,
  renderZipCode,
  renderInteger,
  renderDropdown,
  renderAdditionalComments,
  renderFile,
  renderMultiTextBox,
  renderEffectiveDate,
} from "./RenderUtils";

export class ReplacePropertyLocationRequest extends Component {
  render() {
    var request = this.props.data;
    var updateRequest = this.props.updateRequest;

    return (
      <Form ref={this.props.formRef}>
        <div>
          {renderEffectiveDate(request, updateRequest)}
          {renderMultiTextBox(
            "oldStreetAddress",
            "Old Street Address",
            request,
            updateRequest
          )}
          {renderTextBox(
            "oldCity",
            "City",
            request,
            updateRequest,
            "E.g. Placeholder text"
          )}
          {renderDropdown(
            "oldState",
            "State",
            request,
            updateRequest,
            this.props.states
          )}
          {renderZipCode(
            "oldZipCode",
            "Zip Code",
            request,
            (zipCodePropertyName, zipCodePropertyValue) =>
              this.props.updateAddress(
                zipCodePropertyName,
                zipCodePropertyValue,
                "oldState",
                "oldCity"
              )
          )}
          {renderDropdown(
            "oldConstructionType",
            "Construction Type",
            request,
            updateRequest,
            this.props.constructionTypes
          )}
          {renderInteger(
            "oldSquareFootage",
            "Square Footage",
            request,
            updateRequest,
            "e.g. 1708"
          )}
          {renderMultiTextBox(
            "mailingStreetAddress",
            "Mailing Street Address",
            request,
            updateRequest
          )}
          {renderTextBox(
            "mailingCity",
            "City",
            request,
            updateRequest,
            "E.g. Placeholder text"
          )}
          {renderDropdown(
            "mailingState",
            "State",
            request,
            updateRequest,
            this.props.states
          )}
          {renderZipCode(
            "mailingZipCode",
            "Zip Code",
            request,
            (zipCodePropertyName, zipCodePropertyValue) =>
              this.props.updateAddress(
                zipCodePropertyName,
                zipCodePropertyValue,
                "mailingState",
                "mailingCity"
              )
          )}
          {renderAdditionalComments(updateRequest)}
          {renderFile(request, updateRequest)}
        </div>
      </Form>
    );
  }
}
